import React from "react";
import { Icon, checkFatFill, errorFill, infoFill, closeCircle } from "Icons/index";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";

import cx from "classnames";
import s from "./toastCustom.scss";

export default class ToastCustom extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { className, theme, msg, closeToast } = this.props;

    let toastIcon = checkFatFill;

    if (theme === "error") {
      toastIcon = errorFill;
    } else if (theme === "info") {
      toastIcon = infoFill;
    }

    return (
      <div className={cx(className, s.toastCustom, { [s[theme]]: true })}>
        <div className={s.wrapToast}>
          <Icon className={s.toastIcon} svg={toastIcon} width="1rem" height="1rem" />
          <div className={s.label}>{msg}</div>
        </div>
      </div>
    );
  }
}
